import { useEffect, useState } from "react";
import { Box } from "@mui/material";

// components
import { CheckboxPlanner } from "../../ui/checkbox-planner";
import { CollapsedBox } from "../../ui/collapsed-box";
import { TextFieldStr } from "../../ui/text-field";
import { usePlannerContext } from "../../../services/context/planner-context";

// constants & services
import { MAX_AREA_OFFICE } from "../../../constants/global.constants";
import { TEXT } from "../../../constants/text";
import { useUserContext } from "../../../services/context/user-context";

export const Office = ({ area, nodeId }) => {
  const { viewOnly } = useUserContext();
  const { setNodes, validateStart, setValidateEnd, setErrors } =
    usePlannerContext();
 /*  const [areaEmpty, setAreaEmpty] = useState(false);
  const [employeesEmpty, setEmployeesEmpty] = useState(false); */
  const formValues = area.building;

  const handleValueChange = (value, name) => {
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              building: {
                ...node.data.building,
                [name]: value,
              },
            },
          };
        }
        return node;
      })
    );
  };

/*   useEffect(() => {
    if (validateStart > 0) {
      if (areaEmpty && employeesEmpty) {
        setErrors((prev) => prev + 1);
      }
      setValidateEnd((prev) => prev + 1);
    }
  }, [validateStart, areaEmpty, employeesEmpty]);
 */
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        mt: "16px",
      }}
    >
      {/* <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: 'column',
          gap: "4px",
        }}
      >
         <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "4px",
        }}
      >
        <TextFieldStr
          label={"min. Area"}
          unit="m²"
          placeholder="alternative"
          name="rangeMin"
          value={formValues.rangeMin}
          setValue={handleValueChange}
          area={area}
          shouldBeInteger={false}
          setAlternativeInputsEmpty={setAreaEmpty}
          alternative={true}
          alternativeInputsEmpty={areaEmpty && employeesEmpty}
        />
        <Typography mt={'33px'} fontSize={'12px'} color="#343745">or</Typography>

        <TextFieldStr
          label={"Nr. of Employees"}
          unit=""
          placeholder="alternative"
          name="numEmployees"
          value={formValues.numEmployees}
          setValue={handleValueChange}
          area={area}
          shouldBeInteger={true}
          setAlternativeInputsEmpty={setEmployeesEmpty}
          alternative={true}
          alternativeInputsEmpty={areaEmpty && employeesEmpty}
        />
      </Box>
      {validateStart > 0 && employeesEmpty && areaEmpty && (
        <FormControl
        error={employeesEmpty && areaEmpty}
        variant="standard"
        sx={{ width: "100%" }}
      >
        <FormHelperText sx={{ pl: "8px" }}>
            At least one of the fields must be filled.
          </FormHelperText>
      </FormControl>
          
        )}
      </Box> */}

      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "top",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        <TextFieldStr
          label={"min. Area"}
          unit="m²"
          placeholder="mandatory"
          name="rangeMin"
          requier={true}
          value={formValues.rangeMin}
          maxArea={formValues.rangeMax >= 0 ? formValues.rangeMax : null}
          setValue={handleValueChange}
          area={area}
          secondArea={formValues.rangeMax}
          shouldBeInteger={false}
          /* max={MAX_AREA_OFFICE} */
          min={60}
          tooltip={TEXT.planner.inputs.minAreaOfficeTooltip}
          disabled={viewOnly}
        />

        <TextFieldStr
          label={"max. Area"}
          unit="m²"
          placeholder="optional"
          name="rangeMax"
          value={formValues.rangeMax}
          minArea={formValues.rangeMin >= 0 ? formValues.rangeMin : null}
          setValue={handleValueChange}
          area={area}
          secondArea={formValues.rangeMin}
          shouldBeInteger={false}
          /* max={MAX_AREA_OFFICE} */
          min={60}
          tooltip={TEXT.planner.inputs.maxAreaOfficeTooltip}
          disabled={viewOnly}
        />
      </Box>
      <TextFieldStr
        label={"min. Nr. of Storeys"}
        unit=""
        placeholder="optional"
        name="stories"
        value={formValues.stories}
        setValue={handleValueChange}
        area={area}
        shouldBeInteger={true}
        tooltip={TEXT.planner.inputs.storeysTooltip}
        disabled={viewOnly}
      />

      <TextFieldStr
        label={"Cost per m²GFA"}
        unit="€/m²GFA"
        placeholder="optional"
        name="cost"
        value={formValues.cost}
        setValue={handleValueChange}
        area={area}
        tooltip={TEXT.planner.inputs.costTooltip}
        max={10000}
        disabled={viewOnly}
      />

      <CheckboxPlanner
        label={"Isolated"}
        value={formValues.isolated}
        setValue={handleValueChange}
        name="isolated"
        area={area}
        tooltip={TEXT.planner.inputs.isolatedTooltip}
        disabled={viewOnly}
      />
      {/*  <CollapsedBox height={214}>//300
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <TextFieldStr
            label={"max. Area"}
            unit="m²"
            placeholder="optional"
            name="rangeMax"
            value={formValues.rangeMax}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={false}
          />

          <TextFieldStr
            label={"Max. Stories"}
            unit=""
            placeholder="optional"
            name="maxStories"
            value={formValues.maxStories}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
          />

          <TextFieldStr
            label={"Cost per m²GFA"}
            unit="€/m²GFA"
            placeholder="optional"
            name="costGFA"
            value={formValues.costGFA}
            setValue={handleValueChange}
            area={area}
          />
        </Box>
      </CollapsedBox> */}
    </Box>
  );
};
